import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import { StartActionActivity } from "../../../../../api/omnimap/omnimapApi";

class ToevoegenToezichthouder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async hadleSubmit() {
    $("#cover-spin").show(0);
    //** save Toezichthouders
    var toezichthouderModel = {
      toezichthouders: [],
    };
    var toezichthouder = $("input[name=toezichthouder]:checked");
    for (let i = 0; i < toezichthouder.length; i++) {
      var content = {
        identification: toezichthouder[i].id,
        display: [
          {
            path: "$.alias",
            value: toezichthouder[i].nextSibling.innerText,
          },
        ],
      };
      toezichthouderModel.toezichthouders.push(content);
    }
    await GC.StartActivity(
      toezichthouderModel,
      [window.$catalog_work_plans_selectedIds],
      "df461440-0f13-40f8-a8c3-c8b2a6f7c4e8",
      this.submitCallback,
      window.$catalog_management_units_token
    );
  }
  submitCallback() {
    GC.sleep(1000).then(() => {
      $("#toevoegen_toezichthouder").modal("hide");
      $("#cover-spin").hide(0);
    });
  }
  async componentDidMount() {
    $("#toevoegen_toezichthouder").on("show.bs.modal", async function (event) {
      await omnimap
        .GetUserByRoleAction(
          1,
          30,
          "toezichthouder",
          window.$catalog_management_units_token
        )
        .then((result) =>
          CallBackFunctions.ToevoegenToezichthouderCallbackForCreate(
            result,
            "toevoegen-toezichthouder",
            "toezichthouder"
          )
        );
    });
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="toevoegen_toezichthouder"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Toevoegen toezichthouder(s)</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* //** Toevoegen toezichthouder(s) */}
                <div className="modal-scroll">
                  <label>Toezichthouders </label>
                  <div id="toevoegen-toezichthouder" className="radio-grp" />
                </div>

                <br />
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="save-werkplann"
                  className="btn-modal"
                  onClick={this.hadleSubmit.bind(this)}
                >
                  Verwerken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ToevoegenToezichthouder;
